<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
    <div class="page-wrapper">
      <div class="content">
        <div class="welcome-container">
          <div class="welcome-card">
            <i class="fas fa-users text-primary welcome-icon"></i>
            <h1 class="welcome-title">Welcome to iCRM</h1>
            <p class="welcome-text">
              Your ultimate solution for customer relationship management. <br />
              Start managing your data efficiently today!
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        title: "Welcome to iCRM",
      };
    },
  };
  </script>
  
  <style scoped>
  .welcome-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
  }
  
  .welcome-card {
    text-align: center;
    background: transparent;
    padding: 40px;
    /* border-radius: 10px; */
    /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); */
    animation: fadeIn 1s ease-in-out;
    max-width: 600px;
  }
  
  .welcome-icon {
    font-size: 50px;
    color: #007bff;
    margin-bottom: 15px;
  }
  
  .welcome-title {
    font-size: 30px;
    font-weight: bold;
    color: #333;
  }
  
  .welcome-text {
    font-size: 16px;
    color: #666;
  }
  
  /* Animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  </style>
  